import React, {useEffect, useState, useImperativeHandle, forwardRef} from 'react'
import { Alert, Modal, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import toastr from 'toastr'
import { getVaccines } from '../../redux/vaccines/actions'
import { getVaccinesEmp, saveVaccinesEmp, editVaccinesEmp, deleteVaccinesEmp } from '../../redux/vaccinesEmployees/actions'
import messages from '../../redux/messages'
import CustomTable from '../../components/CustomTable'
import {getBase64} from '../../components/gestorDocumental/GestorDocumental'
import LinkDescargaListGD from '../../components/gestorDocumental/LinkDescargaListGD'
import LinkDescargaGD from '../../components/gestorDocumental/LinkDescargaGD'
import config from '../../config';
//import {  } from 'react-router-dom'

const UserVaccinationComponent = (props, ref) => {
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [requiredDateGD, setRequiredDateGD] = useState(false);
  const [carnetVacunacionInvalid, setCarnetVacunacionInvalid] = useState(false)
  //* Variables
  const columns = [
    {
      Header: 'Vacuna',
      accessor: 'vacuna_list[0].nombre'
    },
    {
      Header: 'Laboratorio',
      accessor: 'vacuna_list[0].laboratorio_list[0].nombre'
    },
    {
      Header: 'Fecha de la dósis',
      accessor: 'fecha',
      Cell: value => (moment(value.row.original.fecha).format('DD/MM/YYYY'))
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
        {
          value.row.original.archivo_gestor && (
            <LinkDescargaListGD 
              id={value.row.original.id} 
              filters={{email: email, id: value.row.original.archivo_gestor[0].id_documento, llave: value.row.original.archivo_gestor[0].llave}} 
              origen={value.row.original.archivo_gestor[0].origen}
              icono={(<i className="material-icons">file</i>)}
              cType={value.row.original.archivo_gestor[0].contentTypeGD} />
          ) 
        }
      </div>)
    }
  ];

  const { vacunacion, email } = config.gestorDocumental;
  
  //Redux
  const dispatch = useDispatch();
  //const { areas, carpetas, loadingAreas, loadingCarpetas } = useSelector(store => store.gestorDocumental);
  //EmpVaccines
  const loading = useSelector(store => store.vaccinesEmp.loading);
  const data = useSelector(store => store.vaccinesEmp.vacsEmp);
  //const dataLenght = useSelector(store => store.health.vacsEmpLength);
  const saveHealthLoader = useSelector(store => store.vaccinesEmp.saveLoading);

  //vaccines
  const vacs = useSelector(store => store.vaccines.vacs);
  const vacsLoader = useSelector(store => store.vaccines.loading);
    

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  useImperativeHandle(ref, () => ({
    onAdd
  }))

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  const filtersVaccinesEmp = () => {
    return {
      filter: props.id,
      itype: parseInt(props.type),
      empleado: props.id
    }
  }

  useEffect(() => {
    dispatch(getVaccinesEmp(filtersVaccinesEmp()));
    dispatch(getVaccines({itype: parseInt(props.type)}));
  }, []);//dispatch, props.id, props.type


  //const oSaveDoc = req => dispatch(saveDoc(req))

  const onSubmit = async e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    let isInputFileValid = true;

    if(e.target.carnetvacunacion.files.length === 0){
      setCarnetVacunacionInvalid(true);
      setValidated(false);
      isInputFileValid = false;
    }

    if(e.target.carnetvacunacion.files.length > 0){
      if((e.target.carnetvacunacion.files[0].size) / 1024 > 20480){ //
        toastr.info('La archivo, sobrepasa el máximo admisible de 20 megabytes');
        setCarnetVacunacionInvalid(true);
        setValidated(false);
        isInputFileValid = false;
      }else{
        setCarnetVacunacionInvalid(false);
      }
    }

    if(!isInputFileValid){
      return;
    }

    if(props.carpetas.length === 0 || props.areas.length === 0){
      toastr.info('Lo sentimos la información necesaria no realizar el registro no esta completa, por favor contacte con el administrador del sistema');
      return;
    }

    let reqGDVacunacion = {}; 
    
    try {
      const filebase64 = await getBase64(e.target.carnetvacunacion.files[0]);
      //const aName = e.target.carnetvacunacion.files[0].name.split('.');
      const fileName = e.target.carnetvacunacion.files[0].name;
      const fName = String(fileName).substring(0, String(fileName).lastIndexOf('.')).replace(/\W/g, '');
      const fExt = `.${String(fileName).substr( (fileName.lastIndexOf(".")+1 - fileName.length) )}`;
      const aFileBase = String(filebase64).split(',');
      reqGDVacunacion = {
        id_area:  props.areas[0].id,
        id_carpeta_encabezado: props.carpetas.find(item => item.descripcion===vacunacion.carpeta).id,
        empresa: props.empresa,
        zona: props.divicion,
        tipo_documento_GD: vacunacion.tipoDocumentoGD,
        descripcion: vacunacion.descripcion, 
        id_empleado: props.id,
        tipo_documento: vacunacion.tipoDocumento,
        archivo: aFileBase[1],
        fecha: moment(e.target.fechaEntrega.value).format('YYYY-MM-DD'),
        //origen: `${String(aName[0]).trim().replaceAll('-', '')}.${aName[1]}`,
        origen: fName + fExt,
        extension: fExt,
        id_registro: 0,
        contentTypeGD: `${aFileBase[0]},`
      }
      //const filtersDcs = filtersDocs();
      //dispatch(saveDoc(reqGDEstadoCivil, filtersDcs));
    } catch (error) {
      toastr.info('Error al subir archivo');
      setCarnetVacunacionInvalid(true);
      setValidated(false);
      return;
    }
    
    const oData = {
      vacuna: e.target.vacuna.value,
      fecha: moment(e.target.fecha.value).format('YYYY-MM-DD'),
			empleado: parseInt(props.id)
    }


    if(edit){
      dispatch(editVaccinesEmp(oData, editItem.id, index, parseInt(props.type), reqGDVacunacion, editItem.archivos_gestor));
      setShowModal(false);
    }else{
      dispatch(saveVaccinesEmp(oData, parseInt(props.type), reqGDVacunacion));
      e.target.reset();
      setShowModal(false);
    }

  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteVaccinesEmp(id, index, parseInt(props.type)));
    }
  }

  return (
    <>
      {
        loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center" />
          </div>
        ) : data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable
                  columns={columns}
                  data={data} />
              </Card.Body>
            </Card>
          </>
        ) : (
          <Alert variant="info" className="my-4">
            No tiene vacunas registradas, comience agregandolas.
          </Alert>
        )
      }
      
      <Modal
        show={showModal}
        size="md"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar lista de vacunas' : 'Crear lista de vacunas'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            {/* <Row> */}
            <Form.Group as={Col} controlId="checklist">
                <Row className="align-items-end">
                  <Col sm={ vacsLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Nombre de la vacuna / Nombre del Laboratorio </Form.Label>
                    <Form.Control
                      as="select"
                      id="vacuna"
                      name="vacuna"
                      className="rounded-pill"
                      required
                      disabled={(parseInt(props.type)===1) ? edit : false}
                      defaultValue={ edit ? editItem.vacuna : null}
                      placeholder="Documento">
                        {
                          vacs.map(item => (
                            <option key={item.id} value={item.id}>{item.nombre} / {item.laboratorio_list[0].nombre}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    vacsLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
              {/* <Form.Group as={Col} controlId="checklist">
                <Row className="align-items-end">
                  <Col>
                    <Form.Label className="ml-2">Dosis Aplicada</Form.Label>
                    <Form.Control
                      as="select"
                      id="dosis"
                      name="dosis"
                      className="rounded-pill"
                      required
                      defaultValue={ edit ? editItem.dosis : null}
                      placeholder="Documento">
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group> */}
              <Form.Group as={Col} controlId="fecha">
                <Form.Label className="ml-2">Fecha</Form.Label>
                <Form.Control
                  name="fecha"
                  className="rounded-pill"
                  required
                  disabled={(parseInt(props.type)===1) ? edit : false}
                  type="date"
                  defaultValue={edit ? editItem.fecha : null}
                  placeholder="Fecha"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            {/* </Row> */}
            <Form.Group as={Col} className="mt-2 text-left" controlId="carnetvacunacion">
              <Form.File
                className={carnetVacunacionInvalid ? `is-invalid`: ''}
                id="carnetvacunacion">
                <Form.File.Label>Carnet de vacunación</Form.File.Label>
                <Form.File.Input
                  required={!edit || (edit && editItem.archivos_gestor === null)}
                  accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx" 
                  name="carnetvacunacion"
                  onChange={e => setRequiredDateGD(e.target.files.length > 0)} />
              </Form.File>
              <small>Peso máximo permitido 200 megabytes</small>
              <Form.Control.Feedback type="invalid">
                <ul className="list-unstyled">
                  <li>
                    **El peso máximo permitido es de 200 megabytes.
                  </li>
                  <li>
                    **Es requerido un archivo con formato pdf, imagen, word, excel.
                  </li>
                </ul>
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="mt-2" controlId="fechaEntrega">
              <Form.Label>Fecha de entrega</Form.Label>
              <Form.Control
                required={requiredDateGD}
                className="rounded-pill"
                type="date"
                name="fechaEntrega"></Form.Control>
              <small className="form-text text-muted">
                Fecha en la que obtuvo el documento
              </small>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            {
              edit && editItem.archivo_gestor ? (
                <>
                  <h6 className="text-muted ml-3">Archivo actual</h6>
                  <ul className="list-unstyled">
                    <LinkDescargaGD 
                      id={editItem.id} 
                      filters={{email: email, id: editItem.archivo_gestor[0].id_documento, llave: editItem.archivo_gestor[0].llave}} 
                      origen={editItem.archivo_gestor[0].origen}
                      cType={editItem.archivo_gestor[0].contentTypeGD} />
                  </ul>
                </>
              ) : null
            }
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveHealthLoader}  
              variant="primary" 
              type="submit">
                {
                  saveHealthLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default forwardRef(UserVaccinationComponent)
